import { Component, OnInit, ViewChild } from '@angular/core';

import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { Acesso } from 'src/app/core/acesso';
import { Atividade } from 'src/app/core/atividade';
import { AtividadeAluno } from 'src/app/core/atividade-aluno';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { ComboAluno } from 'src/app/core/combo-aluno';
import { FilterAlunos } from 'src/app/core/filter-alunos';
import { AtividadeAlunoService } from 'src/app/services/atividade-aluno/atividade-aluno.service';
import { AtividadeService } from 'src/app/services/atividade/atividade.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { ConfirmDialogComponent } from '../common/confirm-dialog/confirm-dialog.component';



@Component({
  selector: 'app-atividade-aluno',
  templateUrl: './atividade-aluno.component.html',
  styleUrls: ['./atividade-aluno.component.css']
})
export class AtividadeAlunoComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;


  filtro: FilterAlunos = new FilterAlunos();

  atividadesAlunos: AtividadeAluno[];
  atividadeAluno: AtividadeAluno = new AtividadeAluno();


  atividades: Atividade[];
  atividade: Atividade;

  msg: string;
  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil;

  mostrarTabela = false;

  displayedColumns: string[] = ['aluno', 'atividade', 'dataCadastroAtividade','dataInicioAtividade', 'acoes'];
  dataSource: MatTableDataSource<AtividadeAluno> = new MatTableDataSource();
  area: string;
  menu: string;
  constructor(
    private atividadeAlunoService: AtividadeAlunoService,
    private atividadeService: AtividadeService,
    private toastService: ToastService,
    private router: Router,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute
  ) { 
    this.carregarPerfil = new CarregarPerfil();
  }

  ngOnInit() {
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);
    this.dataSource.paginator = this.paginator;
    this.limpar();
    this.area = this.getArea();
    this.atividadeService.getAllByArea(this.area).subscribe((atividades: Atividade[]) => {
      this.atividades = atividades;
    });
  }

  getMenu(): string {
    const primeiroSegmento = this.router.url.split('/')[1];
    return primeiroSegmento.startsWith('menu') ? primeiroSegmento : undefined;
  }

  private getArea(): string {
    this.menu = this.getMenu();
    return this.menu && this.menu == "menu-sap" ? 'S' : (this.menu && this.menu == "menu-pedagogico" ? 'P' : null);
  }

  limpar() {
    this.mostrarTabela = false;
    this.atividade = new Atividade();
    this.dataSource.data = [];
    this.filtro = new FilterAlunos();
    this.filtro.aluno = new ComboAluno();
  }

  consultar() {
    if(!this.atividade.id && !this.filtro.aluno.id) {
      this.toastService.showAlerta('Informa pelo menos um parâmetro de pesquisa.');
      return;
    }

    if (this.atividade.id || this.filtro.aluno.id) {
      this.atividadeAlunoService.getFilter(this.atividade.id, this.filtro.aluno.id, this.area)
      .subscribe((atividadeAluno: AtividadeAluno[]) => {
        if (_.isEmpty(atividadeAluno)) {
          this.mostrarTabela = false;
          this.msg = 'Nenhum registro para a pesquisa selecionada';
        } else {
          this.dataSource.data = atividadeAluno;
          this.mostrarTabela = true;
        }
      });
    }
  }

  atualizar(atividadeAluno: AtividadeAluno) {
    atividadeAluno.atividade.area = this.area;
    const rota = this.menu ? this.menu+'/atividadealuno/cadastrar':'atividadealuno/cadastrar';
    this.router.navigate([rota], { queryParams: { idAtividadeAluno: atividadeAluno.id } });
  }

  deletar(atividadeAluno: AtividadeAluno) {
    this.chamaCaixaDialogo(atividadeAluno);
  }

  chamaCaixaDialogo(atividadeAluno: AtividadeAluno) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      pergunta: `Certeza que deseja excluir a atividadeAluno?`,
      textoConfirma: 'SIM',
      textoCancela: 'NÃO'
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirma => {
      if (confirma) {
        this.atividadeAlunoService.excluir(atividadeAluno.id).subscribe(() => {
          this.atividadeAluno.id = null;
          this.consultar();
        })
      } else {
        dialogRef.close();
      }
    }
    );
  }

  onValorChange(event: any) {
    this.filtro.aluno = event;
  }
}
